import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Store } from "store";
import { modalActions } from "../modules/modal";

export const withRequireLogin = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>
) => {
  const WithRequireLogin = (props: P): JSX.Element => {
    const isLogin = useSelector((store: Store) => store.auth.isLogin);
    const dispatch = useDispatch();

    useEffect(() => {
      if (!isLogin) {
        dispatch(modalActions.toggleLoginMethod());
      }
    }, [isLogin, dispatch]);

    // emotion の JSX namespace では型引数 P のままの spread が LibraryManagedAttributes を解決できないため createElement を使う
    return React.createElement(Component, props);
  };
  return WithRequireLogin;
};
